import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../auth/AuthContext';
import { FaSyncAlt } from 'react-icons/fa';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const ViewClubPage = () => {
  const { token } = useContext(AuthContext);
  const [coaches, setCoaches] = useState([]);
  const [clubSecret, setClubSecret] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const fetchCoaches = async () => {
    try {
      const res = await fetch('https://vballbackend.onrender.com/api/club/info', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setCoaches(data.coaches || []);
      setClubSecret(data.club_secret || '');
    } catch (err) {
      console.error('Failed to fetch coaches', err);
    }
  };

  const handleRefreshSecret = async () => {
    const confirmed = window.confirm("Generate a new club secret? This will replace the current one.");
    if (!confirmed) return;

    try {
      const res = await fetch('https://vballbackend.onrender.com/api/club/refresh_secret', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setClubSecret(data.club_secret || '');
    } catch (err) {
      console.error('Failed to refresh secret', err);
    }
  };

  useEffect(() => {
    fetchCoaches();
  }, [token]);

  const filteredCoaches = coaches.filter(coach =>
    coach.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container" style={{ paddingTop: '2rem' }}>
      <h1 className="mb-4">Club Coaches</h1>

      <div className="card">
        {/* Club Secret */}
        <div className="flex-row mb-4" style={{ alignItems: 'center', gap: '1rem' }}>
          <h4 className="mb-0">Club Secret:</h4>
          <span className="text-mono" style={{ flexGrow: 1 }}>{clubSecret}</span>
          <button className="btn-secondary" onClick={handleRefreshSecret}>
            <FaSyncAlt />
          </button>
        </div>

        {/* Search */}
        <input
          className="mb-4"
          type="text"
          placeholder="Search coaches by name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {/* Coach List */}
        <div className="flex-row" style={{ flexWrap: 'wrap', gap: '2rem', justifyContent: 'center' }}>
          {filteredCoaches.map(coach => (
            <div key={coach.id} className="flex-col" style={{ alignItems: 'center', textAlign: 'center' }}>
              <img
                src={coach.photo_url || 'https://placehold.co/100x100?text=Coach'}
                alt={coach.name}
                style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
              <div className="mt-2">{coach.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ViewClubPage;
